<hr>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card card-plain border-0">
        <div class="card-body">
          <form [formGroup]="form">
            <div class="row">
              <div class="col-md-2" [ngClass]="{'ocult':isGestor}">
                <label for="matricula_origem">Cautela de Origem</label>
                <div class="form-group">
                  <input type="text" readonly class="form-control" placeholder="Matricula de origem"
                    id="matricula_origem" formControlName="cD_CDU_MATRICULA_ORIGEM">
                </div>
              </div>
              <div class="col-md-5" [ngClass]="{'ocult':isGestor}">
                <label for="nome_origem">Nome de origem</label>
                <div class="form-group">
                  <input type="text" readonly class="form-control text-center" placeholder="Matricula de origem"
                    id="nome_origem" [value]="name">
                </div>
              </div>
              <div class="col-md-6" [ngClass]="{'ocult':!isGestor}">
               
                <div class="form-group">
                  <label>Cautela de origem:</label>
                  <ng-autocomplete 
                  id="origem"
                  [data]="subordinado"
                  placeholder="Pesquise aqui a cautela de origem..."
                  [searchKeyword]="keywordMatriculaOrigin"
                  (selected)='selecionaOrigem($event)'
                  [itemTemplate]="itemTemplateOrigem"
                  [notFoundTemplate]="notFoundTemplateOrigem"
                  notFoundText="Nenhum resultado encontrado"
                  (inputCleared)="clearInputUser()">                                 
                </ng-autocomplete>
                
                <ng-template #itemTemplateOrigem let-item>
                <span [innerHTML]="item.nome">
                </span>
               
                </ng-template>
                
                <ng-template #notFoundTemplateOrigem let-notFound>
                <div [innerHTML]="notFound"></div>
                </ng-template>
              
                </div>
              </div>
              <div class="col-md-4 mx-auto">
                <div class="form-group">
                    <label for="meuBem">Meus Bens</label>
                    <div class="input-group input-group-sm mb-5">
                      <div class="form-group">
                        <input type="text" class="form-control"
                          (blur)="getBem()"
                          id="meuBem" formControlName="dS_BPM_ETIQUETA_BEM">
                      </div>
                      
                    </div>
                
                    </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                  <label for="meuBem">Descrição Bem</label>
                  <div class="col-12 p-0 input-group input-group-sm mb-5">
                    <div class="form-group col-12 p-0">
                      <input readonly type="text" class="form-control"
                        (blur)="getBem()"
                        id="meuBem" [value]="descricaoBem">
                    </div>
                    
                  </div>
              
                  </div>
          </div>
              <div class="col-md-4 mx-auto">
                <div class="form-group">
                    <label for="location">Unidade Operacional</label>
                    
                        <ng-autocomplete 
                        id="location"
                        [data]="localizacao"
                        [searchKeyword]="keywordUnidade"
                        (selected)='selectEvent($event)'
                        [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate"
                        (inputCleared)="clearInputLoc()">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.dS_BPM_UNIDADE">
                      </a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
                    
                
                    </div>
            </div>
              <div class="col-md-6">
                <div class="form-group">
                    <label for="matricula_destino">Matricula Destino</label>
                    
                        <ng-autocomplete 
                        id="matricula_destino"
                        [data]="data"
                        [searchKeyword]="keywordMatriculaDest"
                        (selected)='selectDest($event)'
                        [itemTemplate]="itemTemplateMatriculaDest"
                        [notFoundTemplate]="notFoundTemplateDest"
                        value=""
                        (inputCleared)="clearInputDest()">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateMatriculaDest let-item>
                        <a [innerHTML]="item.nome"></a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplateDest let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
                  </div>
            </div>
              <div class="col-md-2">
                <label for="sala">Sala</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Sala"
                    id="sala" formControlName="dS_BPM_SALA_POSTERIOR">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheck1">
                      <label class="custom-control-label" for="customCheck1">Alienação</label>
                  </div>
                </div>
              </div>
              
            </div>
          </form>
          <div class="row">
            <div class="col-md-12 text-center" *ngIf="loading">
              <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
            </div>
          </div>
        </div>
        <div *ngIf="!loading" class="modal-footer">
          <div class="left-side col-6 text-center mx-auto">
            <button type="button" class="btn btn-success btn-link" (click)="submit()">
              Alterar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>